// import React, { createContext, useContext, useEffect, useState } from "react";

// const LanguageContext = createContext();

// export const LanguageProvider = ({ children }) => {
//   const [lang, setLang] = useState("en");
//   const [isReady, setIsReady] = useState(false);

//   // helper для перевода
//   const t = (obj) => obj[lang] || obj.en;

//   useEffect(() => {
//     const savedLang = localStorage.getItem("lang");

//     if (savedLang) {
//       setLang(savedLang);
//       setIsReady(true);
//       return;
//     }

//     // 🌍 IP GEO (простая версия)
//     fetch("https://ipapi.co/json/")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data?.country_code === "UA") {
//           setLang("uk");
//           localStorage.setItem("lang", "uk");
//         } else {
//           setLang("en");
//           localStorage.setItem("lang", "en");
//         }
//       })
//       .catch(() => {
//         setLang("en");
//         localStorage.setItem("lang", "en");
//       })
//       .finally(() => setIsReady(true));
//   }, []);

//   return (
//     <LanguageContext.Provider value={{ lang, setLang, t }}>
//       {isReady ? children : null}
//     </LanguageContext.Provider>
//   );
// };

// export const useLanguage = () => useContext(LanguageContext);


// import React, { createContext, useContext, useEffect, useState } from "react";
// import { translations } from "../i18n"; // ⬅️ ДОБАВИЛИ

// import en from "../i18n/en";
// import ua from "../i18n/ua";

// const dictionaries = {
//   en,
//   uk: ua, // ⚠️ ключ = uk
// };

// const LanguageContext = createContext();

// export const LanguageProvider = ({ children }) => {
//   const [lang, setLang] = useState("en");
//   const [isReady, setIsReady] = useState(false);

//   // 🔑 НОВАЯ логика перевода
//   const t = (path) => {
//     const keys = path.split(".");
//     let value = translations[lang];

//     for (const key of keys) {
//       value = value?.[key];
//     }

//     // fallback на en или ключ
//     return value || path;
//   };

//   useEffect(() => {
//     const savedLang = localStorage.getItem("lang");

//     if (savedLang) {
//       setLang(savedLang);
//       setIsReady(true);
//       return;
//     }

//     fetch("https://ipapi.co/json/")
//       .then((res) => res.json())
//       .then((data) => {
//         const detectedLang = data?.country_code === "UA" ? "uk" : "en";
//         setLang(detectedLang);
//         localStorage.setItem("lang", detectedLang);
//       })
//       .catch(() => {
//         setLang("en");
//         localStorage.setItem("lang", "en");
//       })
//       .finally(() => setIsReady(true));
//   }, []);

//   return (
//     <LanguageContext.Provider value={{ lang, setLang, t }}>
//       {isReady ? children : null}
//     </LanguageContext.Provider>
//   );
// };

// export const useLanguage = () => useContext(LanguageContext);


import React, { createContext, useContext, useEffect, useState } from "react";

import en from "../i18n/en";
import ua from "../i18n/ua";

const dictionaries = {
  en,
  uk: ua, // важно: ключ = uk
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const [isReady, setIsReady] = useState(false);

  // 🔑 функция перевода
  const t = (path) => {
    const keys = path.split(".");
    let value = dictionaries[lang];

    for (const key of keys) {
      value = value?.[key];
    }

    // ✅ если функция — вызываем
  if (typeof value === "function") {
    return value();
  }



    // fallback: EN → ключ
    if (!value && lang !== "en") {
      let fallback = dictionaries.en;
      for (const key of keys) {
        fallback = fallback?.[key];
      }
      return fallback || path;
    }

    return value || path;
  };

  useEffect(() => {
    const savedLang = localStorage.getItem("lang");

    if (savedLang) {
      setLang(savedLang);
      setIsReady(true);
      return;
    }

    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        const detectedLang = data?.country_code === "UA" ? "uk" : "en";
        setLang(detectedLang);
        localStorage.setItem("lang", detectedLang);
      })
      .catch(() => {
        setLang("en");
        localStorage.setItem("lang", "en");
      })
      .finally(() => setIsReady(true));
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {isReady ? children : null}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
